<template>
  <div>
    <v-card class="pb-4">
      <v-toolbar dense flat>
        <v-toolbar-title>Report Historical Trade Executions</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-container fluid>
        <v-layout>
          <v-flex xs12 md4>
            <v-menu
              :close-on-content-click="false"
              v-model="openDatepicker"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                :disabled="dataLoading"
                v-model="stringDate"
                label="Date"
                prepend-icon="event"
              ></v-text-field>

              <v-date-picker
                v-model="stringDate"
                :max="maxDateSelected"
                no-title
                @input="openDatepicker = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="defaultToken"
              :items="tokenSelect"
              prepend-icon="fas fa-coins"
              menu-props="auto"
              hide-details
              disabled
              label="Select"
              single-line
            ></v-select>
          </v-flex>
        </v-layout>
        <v-btn :loading="dataLoading" :disabled="dataLoading" color="primary" @click="searchData">
          Search
          <v-icon right dark>fas fa-search</v-icon>
        </v-btn>
      </v-container>
    </v-card>
    <div v-if="data">
      <v-card>
        <v-toolbar dense flat>
          <v-toolbar-title>Daily Report</v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            <v-autocomplete
              v-model="exchangeName"
              :items="exchangeAccounts"
              item-text="key"
              item-value="value"
              clearable
            ></v-autocomplete>
          </div>
        </v-toolbar>
        <v-container fluid grid-list-md>
          <v-data-iterator
            :items="data"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            content-tag="v-layout"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
              <v-card>
                <v-card-title>
                  <h3>{{ props.item._id }}</h3>
                </v-card-title>
                <v-divider></v-divider>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Base Currency:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.base_currency }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Quote Currency:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.quote_currency }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Base Amount:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.base_amount }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Quote Amount:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.quote_amount }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Fee Base:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.fee_base }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Fee Quote:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.fee_quote }}</v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile>
                    <v-list-tile-content>
                      <b>Count:</b>
                    </v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ props.item.count }}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-data-iterator>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import MongoService from '../../services/mongo.service'
import MongoConnector from '../../services/mongo-connector.service'
import { getDefaultConnectorSchema } from '../../configs/schemas'
import moment from 'moment'
export default {
  data() {
    const historicalService = new MongoConnector(
      getDefaultConnectorSchema(null, 'historical-sales')
    )
    return {
      stringDate: moment().format('YYYY-MM-DD'),
      defaultData: null,
      maxDateSelected: moment().format('YYYY-MM-DD'),
      historicalService,
      openDatepicker: false,
      dataLoading: false,
      data: null,
      exchangeName: null,
      defaultToken: 'XRP',
      tokenSelect: [],
      exchangeAccounts: [],
      rowsPerPageItems: [8, 12, 16],
      pagination: {
        rowsPerPage: 8
      }
    }
  },
  async beforeMount() {
    this.dataLoading = true
    const historicals = await this.historicalService.find({
      filter: { sale_date_id: this.stringDate }
    })
    this.tokenSelect = historicals.map(historical => historical.token)
    const exchanges = historicals
      .map(historical => {
        if (historical.token === this.defaultToken) {
          return historical.exchanges
        }
      })
      .filter(exchange => exchange !== undefined)
      .flat()

    this.exchangeAccounts = [
      ...new Set(
        exchanges.map(item => ({ key: item.exchange, value: item.exchange }))
      )
    ].sort((a, b) => (a.key < b.key ? -1 : a.key > b.key ? 1 : 0))

    this.dataLoading = false
  },
  methods: {
    async searchData() {
      try {
        this.dataLoading = true
        const token = this.defaultToken
        const result = (await MongoService.api.historicalTradeDailyReport({
          sale_date_id: this.stringDate,
          token
        })).sort(this.CompareSortValueById)

        this.defaultData = result
        this.data = result
        this.dataLoading = false
      } catch (error) {
        this.dataLoading = false
      }
    },
    CompareSortValueById(a, b) {
      if (a._id < b._id) return -1
      if (a._id > b._id) return 1
      return 0
    }
  },
  watch: {
    exchangeName: {
      handler(val) {
        if (val) {
          const regexData = this.defaultData
            ? this.defaultData.filter(data => {
                const testMatch = new RegExp(`${val}`, 'g').test(data._id)
                if (testMatch) {
                  return data
                }
              })
            : null
          this.data = regexData ? regexData : this.data
        } else {
          this.data = this.defaultData ? this.defaultData : this.data
        }
      }
    }
  }
}
</script>
